import React, { useEffect, useState } from "react";
import HeaderAction from "../components/HeaderAction";
import styled from "styled-components";
import Tab from "../components/Tab";
import ListProduct from "../components/ListProduct";
import { ID_PRIZE } from "../components/DefineData";
import iconBg1 from "../../../../assets/images/Event-2026/bg-icon-01.png";
import iconBg2 from "../../../../assets/images/Event-2026/bg-icon-2.png";
import { getCookie, getDataApi, postDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { curStateMiniGame } from "../../../../Redux/selector";
import {
  useDispatch,
  useSelector,
  useMiniGameAuth,
} from "@pages/Events/MiniGame/store";
import { useParams } from "react-router-dom";
import bgTakePrize from "../../../../assets/images/Mini-Game/bg-take-prize-web-x2.png";
import bgTakePrizeThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-take-prize-thadingyut-2025-theme.png";
import bgTakePrizeThadingyutPc from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-take-prize-thadingyut-2025-theme-pc.png";
import bgTakePrizeNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bg-take-prize.png";
import bgTakePrizeNewYearMobile from "../../../../assets/images/Mini-Game/new-year-2025/bg-take-prize-mobile.png";
import framePieceCollection from "../../../../assets/images/Mini-Game/Frame-piece-collection.png";
import framePieceCollectionThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/Frame-piece-collection.png";
import framePieceCollectionNewYear from "../../../../assets/images/Mini-Game/new-year-2025/Frame-piece-collection.png";
import iconPiece from "../../../../assets/images/Mini-Game/delete-define-piece.png";
import pieceCollectionBtn from "../../../../assets/images/Mini-Game/piece-collection-btn.png";
import pieceCollectionBtnNewYear from "../../../../assets/images/Mini-Game/new-year-2025/piece-collection-btn.png";
import { Link } from "react-router-dom";
import PATH from "../../../../config/PATH";
import bgTake from "../../../../assets/images/Event-2026/bg-take-prize.png";
import {
  ID_TAB_MINI_GAME,
  // IS_EVENT_THADINGYUT_2025_THEME,
  TYPE_GIVE_MINIGAME,
  TYPE_GIVE_PIECE,
  TYPE_REQUEST_PIECE,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../helper/const";
import _ from "lodash";
import {
  confirmPieceLinkMiniGame,
  pieceLinkMiniGame,
  setDataPopupError,
  setOpenPopupGivePiece,
} from "../../../../Redux/futures/mini-game/action";
import { useTranslation } from "react-i18next";
import { mediaQueryPoint, useMediaQuery } from "../../../../utils/hooks";

export default function PieceCollection() {
  const { requireLogin } = useMiniGameAuth();
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);
  const { awardId } = useParams();
  const [itemProductActive, setItemProductActive] = useState(awardId);
  const [dataAwardActive, setDataAwardActive] = useState([]);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
  const isPcSmall = useMediaQuery(
    `(min-width: ${mediaQueryPoint.lg}px) and (max-width: ${mediaQueryPoint.xxl}px)`
  );
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  const bgTakePrizeThadingyutTheme = isMobile
    ? bgTakePrizeThadingyut
    : bgTakePrizeThadingyutPc;

  const bgTakePrizeNewYearTheme = isMobile
    ? bgTakePrizeNewYearMobile
    : bgTakePrizeNewYear;

  useEffect(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      return;
    }
    if (!awardId) {
      const dataSort = dataMiniGame.dataAwardListMini.sort(
        (a, b) => Number(a.rank) - Number(b.rank)
      );
      setItemProductActive(dataSort[0]?.id);
    }
  }, [dataMiniGame.dataAwardListMini]);

  const afterRequest = (data, isLoading, dataError) => {
    if (data && data?.data?.code) {
      dispatch(
        setOpenPopupGivePiece({
          isShow: true,
          link: `http://reverseauction.com.mm/mini-game/request/${data.data.code}`,
          type: TYPE_REQUEST_PIECE.requestLink,
        })
      );
    } else if (dataError) {
      dispatch(
        setDataPopupError({
          isOpen: true,
          message: "",
        })
      );
    }
  };

  const handleRequest = async (item = {}) => {
    // check user đăng nhập chưa
    if (!requireLogin()) {
      return;
    }

    const dataApi = {
      type: TYPE_GIVE_MINIGAME.request,
      piece_id: item.id,
      callback: afterRequest,
      piece_number: 1,
    };
    dispatch(pieceLinkMiniGame(dataApi));
  };
  const handleGive = (item = {}) => {
    // check user đăng nhập chưa
    if (!item.num) {
      return null;
    }
    if (!requireLogin()) {
      return;
    }

    let awardName = "";
    const dataAwardListMini = dataMiniGame.dataAwardListMini || [];
    dataAwardListMini.forEach((itemAward) => {
      if (+itemAward.id === +item.minigame_award_id) {
        awardName = itemAward.name;
      }
    });

    dispatch(
      setOpenPopupGivePiece({
        isShow: true,
        link: "",
        data: { ...item, awardName },
        type: TYPE_GIVE_PIECE.give,
      })
    );
  };

  //
  const handleGetDataCollected = async () => {
    setDataAwardActive([]); 
    const dataApi = await getDataApi(API_PATH.miniGamePieceCollected, {
      award_id: itemProductActive,
    });

     console.log("award", itemProductActive);
  console.log("data", dataApi?.data);

    setDataAwardActive(dataApi?.data);
    // setIsRunout(dataApi?.is_runout);
  };

  useEffect(() => {
    setDataAwardActive([]);

    handleGetDataCollected();
  }, [itemProductActive]);
  const { t } = useTranslation();

  return (
    <Div
      bg={
        IS_EVENT_THADINGYUT_2025_THEME
          ? bgTakePrizeThadingyutTheme
          : IS_EVENT_NEW_YEAR_2025_THEME
            ? bgTakePrizeNewYearTheme
            : bgTakePrize
      }
      className={`${IS_EVENT_THADINGYUT_2025_THEME
        ? "thadingyut-theme"
        : IS_EVENT_NEW_YEAR_2025_THEME
          ? "new-year-25-theme"
          : ""
        }`}
    >
      <Container className='container-thingyan container-minigame'>
        <div className='thingyan-home-header'>
          {/* {!IS_EVENT_THADINGYUT_2025_THEME &&
              !IS_EVENT_NEW_YEAR_2025_THEME && (
                <>
                  <img src={iconBg1} alt='' className='icon-bg-web1' />
                  <img src={iconBg2} alt='' className='icon-bg-web2' />
                </>
              )} */}
          <div className='header-take-prize'>
            <HeaderAction />
          </div>
          <Tab idActive={2} itemProductActive={itemProductActive} />
          <ListProduct
            setItemProductActive={setItemProductActive}
            itemProductActive={itemProductActive}
          />
          {_.isEmpty(dataAwardActive) ? null : (
            <div className='piece-collection-content'>
              <Grid>
                {dataAwardActive.map((item, index) => (
                  <GridItem
                    key={item.id + index}
                    className={`${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""
                      } ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
                      }`}
                  >
                    <div className='count'>x{item.num || 0}</div>

                    <div className='grid-item-content'>
                      <div className='grid-item-img-container'>
                        <img
                          src={item.image_light || iconPiece}
                          alt=''
                          className='grid-item-img'
                        />
                      </div>
                      <div className='grid-item-name'>Pieza {item.name}</div>
                    </div>
                  </GridItem>
                ))}
              </Grid>

              <Link
                to={`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.collectPiece}`}
                className={`btn-earn-more-piece`}
              >
                {t("mini_game.piece_collection.earn_more_piece")}
              </Link>
            </div>
          )}
        </div>
      </Container>
    </Div>
  );
}
const Div = styled.div`
  /* new */
  .container-thingyan .thingyan-home-header {
    background-image: url(${bgTake}) !important;
    background-size: 100% 100%;

    @media (max-width: 600px) {
      background-position: center;
      background-size: 100% 100%;
    }
  }
  /* end new */
  .img-filter-event__2025 {
    filter: drop-shadow(0px 0px 1px white) drop-shadow(0px 0px 1px white)
      drop-shadow(0px 0px 2px white);
  }

  .text-default {
    -webkit-text-stroke: inherit !important;
    font-size: 26px !important;
  }

  &.thadingyut-theme {
    .container-thingyan .thingyan-home-header {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;

      @media (min-width: 768px) and (max-width: 1400px) {
        background-size: 165% 100%;
      }

      @media (min-width: 1400px) and (max-width: 1600px) {
        background-size: 145% 100%;
      }
    }
  }

  &.new-year-25-theme {
    .container-thingyan .thingyan-home-header {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;

      @media (min-width: 768px) and (max-width: 1400px) {
        background-size: cover;
      }

      @media (min-width: 1400px) and (max-width: 1600px) {
        background-size: cover;
      }
    }
  }
`;

const Container = styled.div`
  .header-take-prize {
    padding-top: 18px;
    margin-bottom: 30px;
  }

  .thingyan-home-header {
    overflow-y: hidden;
  }

  .piece-collection-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 90%;
    gap: 32px;
    padding-bottom: 32px;

    @media (max-width: 768px) {
      max-width: 100%;
    }

    @media (max-width: 592px) {
      padding-top: 70px;
    }

    @media (max-width: 525px) {
      padding-top: 10px;
    }


    .btn-earn-more-piece {
          width: 300px;
          margin: 0 auto;
          background: linear-gradient(to right, rgba(30, 163, 23, 1) 0%, rgba(25, 184, 16, 1) 100%);
          padding: 8px 12px;
          border-radius: 5px;
          color: #fff;
          font-weight: 700;
          font-size: 22px;
          margin-top: 20px;
          text-align: center;
          height: 50px;
          @media (max-width: 625px) {
            font-size: 16px;
            height: 42px;
          }
      }

      @media (max-width: 625px) {
        max-width: 460px;
        font-size: 18px;
      }

      @media (max-width: 525px) {
        max-width: 400px;
      }

      @media (max-width: 425px) {
        max-width: 350px;
        font-size: 20px;
        font-size: 16px;
        height: auto;
      }

      @media (max-width: 375px) {
        max-width: 300px;
      }
    }

  @media (max-width: 576px) {
    .header-take-prize {
      padding-top: 10px;
      margin-bottom: 20px;
    }
  }

  @media (min-width: 1400px) {
    .header-take-prize {
      padding-top: 25px;
      padding-left: 22px;
      padding-right: 22px;
    }
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 20px;
  padding: 0px 20px;
  justify-items: center;
  /* max-width: 80%; */
  margin: 0 auto;
  position: relative;
  z-index: 2;

  @media (max-width: 1600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 525px) {
    /* padding: 0; */
    width: 100%;
  }

  @media (max-width: 475px) {
    row-gap: 20px;
    column-gap: 10px;
    padding: 0 10px;
  }
`;

const GridItem = styled.div`
  /* background-image: url(${framePieceCollection}); */
  /* background: linear-gradient(180deg, rgba(65, 84, 255, 1), rgba(96, 112, 255, 1));
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center; */
  background: linear-gradient(
  180deg,
  #A1A3FF 0%,
  #6070FF 100%
);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 235px;
  width: 269px;
  position: relative;
  outline: 4px solid #4154FF80;

   .grid-item-name {
    color: #fff;
    font-size: 30px;
    font-weight: 900;
   }

  &.thadingyut-theme {
    background-image: url(${framePieceCollectionThadingyut});
  }

  &.new-year-25-theme {
    background-image: url(${framePieceCollectionNewYear});

    .btn-request {
      background-color: #d61717 !important;
      color: #fff !important;

      &:hover {
        background-color: #ff0000 !important;
      }
    }

    .btn-give {
      background-color: #560909 !important;
      color: #fff !important;
      border: 1px solid #f3b9b9 !important;

      &:hover {
        background-color: #7a0f0f !important;
      }
    }
  }

  .card-disabled {
    pointer-events: none;
    opacity: 0.5;
    user-select: none;
  }
  .count {
    background: linear-gradient(
      180deg,
      #DD4EFE 0%,
      #8800FF 100%
    );
    /* text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
      1px 1px 0 #fff; */
    height: 32px;
    width: 70px;
    border-bottom-left-radius: 18px;
    border-top-right-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF130;
    font-size: 20px;
    font-weight: 700;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
  }

  .grid-item-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    .grid-item-info {
      width: 100%;
    }

    .grid-item-img-container {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      pointer-events: none;
    }

    .grid-item-img {
      margin: 0 auto;
      display: block;
      width: 150px;
      height: 150px;
      object-fit: contain;
    }

    p {
      font-size: 20px;
      font-weight: 800;
      color: #fff;
      text-shadow: -1px -1px 0 #c76216, 1px -1px 0 #c76216, -1px 1px 0 #c76216,
        1px 1px 0 #c76216;
      text-align: center;
      margin-bottom: 10px;
    }

    .grid-item-action {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 8px;

      .btn-request,
      .btn-give {
        width: 50%;
        background-color: #f97a1c;
        border-radius: 20px;
        font-weight: 600;
        color: #fff;
        border: none;
        height: 41px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
          background-color: #f89c00;
        }
      }

      .btn-give {
        background-color: #fff;
        color: #f97a1c;

        &:hover {
          background-color: #f0f0f0;
        }
      }
    }
  }

  @media (max-width: 625px) {
    background-size: 100% 100%;
    width: 220px;
    height: 220px;

    .grid-item-content {
      .grid-item-img {
        width: 140px;
        height: 140px;
      }

      .grid-item-action {
        .btn-request,
        .btn-give {
          font-size: 13px;
          padding: 0 2px !important;
        }
      }
    }

    .grid-item-name {
      font-size: 20px;
    }
  }

  @media (max-width: 525px) {
    width: 100%;
    height: 190px;
    padding: 14px;
    .grid-item-content {
      .grid-item-img {
        width: 110px;
        height: 110px;
      }}
    /* padding-top: 14px; */
    .count {
      font-size: 16px;
      width: 55px;
    }

    .grid-item-content {
      /* .grid-item-img {
        width: 45%;
      } */
      p {
        font-size: 16px;
      }
      .grid-item-action {
        gap: 4px;

        .btn-request,
        .btn-give {
          font-size: 14px;
          padding: 8px 16px;
        }
      }
    }
  }

  @media (max-width: 475px) {
    height: 175px;

    .count {
      font-size: 14px;
      width: 45px;
    }

    .grid-item-content {
      .grid-item-img {
        width: 110px;
        height: 110px;
      }
      p {
        font-size: 14px;
      }
      .grid-item-action {
        gap: 4px;

        .btn-request,
        .btn-give {
          font-size: 12px;
        }
      }
    }
  }

  @media (max-width: 375px) {
    width: 100%;

    .grid-item-content {
      .grid-item-img {
        width: 95px;
        height: 95px;
      }
      .grid-item-action {
        .btn-request,
        .btn-give {
          font-size: 10px;
          padding: 6px 12px;
        }
      }
    }
  }

  @media screen and (min-width: 768px) and (max-width: 992px) {
    height: 180px;
    width: 200px;

    .grid-item-content .grid-item-img {
        margin: 0 auto;
        display: block;
        width: 90px;
        height: 90px;
        object-fit: contain;
    }

    .grid-item-name {
      font-size: 24px;
    }
  }
`;
